import { useCallback, useState } from 'react';

export default function useDrawerManager() {
  const [isDrawerLoaded, setDrawerLoaded] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const loadDrawer = useCallback(() => setDrawerLoaded(true), []);

  const openDrawer = useCallback(() => {
    loadDrawer();
    setDrawerOpen(true);
  }, [loadDrawer]);

  const closeDrawer = useCallback(() => setDrawerOpen(false), []);

  return {
    isDrawerLoaded,
    isDrawerOpen,
    loadDrawer,
    openDrawer,
    closeDrawer,
  };
}
